import { render, staticRenderFns } from "./EducationBackground.vue?vue&type=template&id=1080e8d0&"
import script from "./EducationBackground.vue?vue&type=script&lang=ts&"
export * from "./EducationBackground.vue?vue&type=script&lang=ts&"
import style0 from "./EducationBackground.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports